<script setup lang="ts">
const contentRef = ref<HTMLElement | null>(null);

const scrollToContent = () => {
  contentRef.value?.scrollIntoView({
    behavior: "smooth",
    block: "start",
  });
};

const emit = defineEmits<{
  (e: "scrollToChoosePlan"): void;
}>();
</script>

<template>
  <div>
    <div
      class="flex flex-col justify-center gap-5 md:hidden"
      style="height: calc(100vh - 160px)"
    >
      <h1 class="mb-5 text-4xl font-bold uppercase">
        Your home for poker entertainment!
      </h1>
      <div class="flex flex-col items-center justify-center gap-5">
        <Button
          class="border-primary-200 text-primary-200"
          outlined
          fluid
          @click="scrollToContent"
        >
          <font-awesome-icon :icon="['fas', 'play']" class="mr-2" />
          Watch
        </Button>
        <NuxtLink
          to="https://playpokergo.onelink.me/YuJc/nh56lr4w"
          target="_blank"
          class="w-full"
        >
          <Button
            fluid
            class="w-full border-primary-200 text-primary-200"
            outlined
          >
            <font-awesome-icon :icon="['fas', 'cards']" class="mr-2" />
            Play
          </Button>
        </NuxtLink>
      </div>

      <div class="mb-4 text-3xl font-bold italic">GET IN THE GAME!</div>
    </div>

    <div ref="contentRef" class="mb-1 pt-10 text-2xl font-medium md:pt-0">
      JOIN TODAY AND START WATCHING!
    </div>
    <div class="text-lg font-medium">PLANS AS LOW AS $8.34/MONTH*</div>
    <Button
      label="Select  Your Plan Now!"
      severity="secondary"
      class="mt-5"
      :pt-options="{ mergeProps: true }"
      :pt="{
        root: 'bg-white  !text-black',
      }"
      @click="emit('scrollToChoosePlan')"
    />
  </div>
</template>

<style scoped></style>
